function Footer() {
  return (
    <footer className="bg-hero-background border-t border-black/10 py-12 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <a
              href="#hero"
              className="font-display font-bold text-xl text-hero-foreground hover:opacity-80 transition-opacity"
            >
              &lt;/&gt; Jack Aguilera
            </a>
            <p className="text-muted-foreground text-sm mt-2">
              © {new Date().getFullYear()} Jack Aguilera. All rights reserved.
            </p>
          </div>

          {/* About Links */}
          <div>
            <h3 className="font-display font-bold text-hero-foreground mb-4">
              About
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#about"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="#skills"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  Skills
                </a>
              </li>
              <li>
                <a
                  href="#education"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  Education
                </a>
              </li>
              <li>
                <a
                  href="#certifications"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  Certifications
                </a>
              </li>
            </ul>
          </div>

          {/* Experience Links */}
          <div>
            <h3 className="font-display font-bold text-hero-foreground mb-4">
              Experience
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#current-role"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  Current Role
                </a>
              </li>
              <li>
                <a
                  href="#past-experiences"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  Past Experiences
                </a>
              </li>
            </ul>
          </div>

          {/* Projects Links */}
          <div>
            <h3 className="font-display font-bold text-hero-foreground mb-4">
              Projects
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#project-0"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  Support Automation System
                </a>
              </li>
              <li>
                <a
                  href="#project-1"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  JSM Automation
                </a>
              </li>
              <li>
                <a
                  href="#project-2"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  Finance Platform
                </a>
              </li>
              <li>
                <a
                  href="#project-3"
                  className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm"
                >
                  AI Movie Recommendation
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-black/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <a href="/privacy-policy" className="no-underline">
            <p className="text-muted-foreground text-sm cursor-pointer hover:underline">
              Privacy Policy
            </p>
          </a>
          <div className="flex gap-6">
            <a
              href="https://github.com/jackaguilera"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm font-semibold"
            >
              GitHub
            </a>
            <a
              href="https://www.linkedin.com/in/jack-aguilera/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-hero-foreground transition-colors text-sm font-semibold"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
